/**
 Validates org numbers from Belgium
 */
export const validateBelgiumOrgNumber = (number: string) => {
  const belgiumOrgNumberRegex = /^[0,1]\d{9}$/g;
  return belgiumOrgNumberRegex.test(number);
};
